import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {CANDIDATES} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('candidates.title'),
                url: CANDIDATES,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('first_name'),
                        type: 'text',
                        key: 'first_name',
                        isVisible: true,
                    },
                    {
                        title: this.$t('last_name'),
                        type: 'text',
                        key: 'last_name',
                        isVisible: true,
                    },
                    {
                        title: this.$t('email'),
                        type: 'text',
                        key: 'email',
                    },
                    {
                        title: this.$t('attachments'),
                        type: 'component',
                        componentName: 'app-attachments-column',
                        key: 'attachments',
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: status => {
                            return `<span class="badge badge-pill badge-${status.class}">
                                ${status.translated_name}
                            </span>`
                        }
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('status'),
                        type: "checkbox",
                        key: "status",
                        option: [],
                        listValueField: 'value'
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        url: CANDIDATES,
                    },
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-candidate-modal',
                        modalId: 'candidate-modal',
                        url: CANDIDATES,
                        name: 'edit',
                        modifier: row => this.$can('update_candidates')
                    },
                    {
                        title: this.$t('candidates.add_note'),
                        type: 'modal',
                        component: 'app-candidate-note-modal',
                        modalId: 'candidate-note-modal',
                        name: 'add-note',
                    },
                    {
                        title: this.$t('candidates.convert_to_employee'),
                        type: 'modal',
                        component: 'app-candidate-move-modal',
                        modalId: 'candidate-move-modal',
                        name: 'convert-to-employee',
                        modifier: row => row.status && row.status.translated_name === 'Interviewed' && this.$can('move_candidate_employees')
                    },
                    {
                        title: this.$t('candidates.delete'),
                        key: 'delete_candidate',
                        url: CANDIDATES,
                        modifier: row => row.id
                    }
                ],
            }
        }
    }
}
